import React from "react";

export default function SupportSection() {
	return (
		<>
			<div className="support-section-container my-5 px-2">
				<div className="support-section">
					<div className="row align-items-center justify-content-center">

						<div className="col-md-6 text-center mb-4 mb-md-0 service-section-left" data-aos="fade-right">
							<h2 className="section-subtitle text-primary">
								Your Business is Our Business. <br /> Dedicated 1 on 1 Support.
							</h2>
							<p className="description text-primary">
								We understand that without the right support from  manufacturing partners,
								it can get extremely tedious to grow at your pace.
								At Midamas, we are always here for you.
								With a dedicated CRM team you get timely support for all your needs.
							</p>
							<div className="text-center">
								<a
									href="https://docs.google.com/forms/d/e/1FAIpQLSdZ0HQ9bqcaCPfBL6OH6dIo7s5Lf2zhAjuqRUMzr2pY4FsPlg/viewform"
									target="_blank"
									rel="noopener noreferrer"
								>
									<button className="primary-button">Set Up a Virtual Meeting</button>
								</a>
								
							</div>
						</div>

						<div className="col-md-6 text-center" data-aos="fade-left">
							<img
								src="/assets/images/aboutus/aboutus_support4.png"
								alt="support"
								className="img-fluid support-lab-image"
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
